<template>
    <dx-grid
        url="donations"
        :columns="columns"
        :title="title"
        :expandedOptions="{
            enabled: true,
            allowExpandingAll: true,
            template: 'donation-details',
        }"
    ></dx-grid>
</template>

<script>
import moment from "moment";
import { formatCurrency } from "../../utils/helpers.js";

export default {
    data: () => ({
        title: "Payments",
        columns: [
            // {
            //     field: "status",
            //     isIcon: true,
            //     template: "icon",
            //     alignment: "center",
            //     visible: true,
            //     allowFiltering: false,
            //     allowHeaderFiltering: false,
            //     allowHiding: false,
            //     allowSearch: false,
            //     cssClass: "width-25",
            //     headerFilter: {
            //         allowSearch: false,
            //         groupInterval: undefined,
            //         height: undefined,
            //         searchMode: "contains",
            //         width: undefined,
            //     },
            //     icon: (value, row) => {
            //         if (row.isVoided && value == "PROCESSED") {
            //             return "mdi-cancel";
            //         }

            //         switch (value) {
            //             case "PROCESSED":
            //                 return "mdi-check-circle";
            //             case "DECLINED":
            //                 return "mdi-alert";
            //             case "ERROR":
            //                 return "mdi-alert-circle";
            //             default:
            //                 return "";
            //         }
            //     },
            //     iconColor: (value, row) => {
            //         if (row.isVoided && value == "PROCESSED") {
            //             return "#aeb8bf";
            //         }

            //         switch (value) {
            //             case "PROCESSED":
            //                 return "success";
            //             case "DECLINED":
            //             case "ERROR":
            //                 return "#f35123";
            //             default:
            //                 return "#aeb8bf";
            //         }
            //     },
            // },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            // {
            //     field: "accountID",
            //     label: "Account ID",
            //     link: "DinnerAccountView",
            //     format: "",
            //     template: "link-cell-template",
            //     visible: true,
            //     filterType: "",
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            //     showLink: (row) => {
            //         return true;
            //     },
            // },
            {
                label: "Date",
                field: "date",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: new Date(
                    moment()
                        .subtract(1, "month")
                        .add(1, "day"),
                ),
                selectedFilterOperation: ">=",
            },
            {
                label: "Total Amount",
                field: "totalAmount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Payment Amount",
                field: "paymentAmount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Schedule Amount",
                field: "scheduleAmount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Phone Number",
                field: "phoneNumber",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Caller ID",
                field: "callerID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Email Address",
                field: "emailAddress",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Source",
                field: "source",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Campaign",
                field: "campaign",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Payment Type",
                field: "paymentType",
                isDropdown: true,
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Authorization Code",
                field: "authorizationCode",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Payment ID",
                field: "paymentID",
                alignment: "left",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Schedule ID",
                field: "scheduleID",
                alignment: "left",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Card Type",
                field: "cardType",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Card Ending",
                field: "cardNumLast5",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Note",
                field: "note",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    methods: {},
};
</script>
<style></style>
